<template>
    <v-card variant="flat" class="px-4 pt-3" style="border-radius: 16px;">
        <v-form ref="form" @submit.prevent="save">
            <v-row>
                <v-col class="px-4 mt-2" cols="12">
                    <div class="d-flex"
                        style="justify-content: space-between !important; align-items: center !important;">
                        <div>
                            <h2 class="main_title">
                               {{ viewType == 'edit'?'Edit': viewType == 'view'?'View':"" }} <span style=" color: rgb(8, 47, 177);">{{designation}}</span> 
                                </h2>
                        </div>
                        <span @click="$emit('close')"  class="mdi mdi-close"></span>
                    </div>
                </v-col>
            </v-row>

            <v-card-text>
                <v-row class="pa-0 mt-2">
                    <v-col cols="12" class="px-0 py-0 d-flex align-center justify-center">
                      <v-radio-group
                        :disabled="viewType === 'view'"
                        v-model="formData.active"
                        inline
                      >
                        <v-radio color="primary" label="Active" :value="1"></v-radio>
                        <v-radio color="error" label="Inactive" :value="0"></v-radio>
                      </v-radio-group>
                    </v-col>
                    <v-col cols="4" class="py-0 px-1">
                        <v-label>Customer <span style="color: red;">*</span></v-label>
                        
                        <TextFieldComponent :rules="getRules('Customer')" placeholder="Customer" :disabled="viewType === 'view'"
                            v-model="formData.customer" />
                    </v-col>
                    <v-col cols="4" class="py-0 px-1">
                        <v-label>Name <span style="color: red;">*</span></v-label>
                        <TextFieldComponent :rules="getRules('Name')" placeholder="Name" :disabled="viewType === 'view'" v-model="formData.name" />
                    </v-col>

                    <v-col cols="4" class="py-0 px-1">
                        <v-label>Ship Type <span style="color: red;">*</span></v-label>
                        <TextFieldComponent :rules="getRules('Ship Type')"  placeholder="Ship Type" :disabled="viewType === 'view'" v-model="formData.ship_type" />
                    </v-col>
                    <v-col cols="12" class="py-0 px-1">
                        <v-label>Shipping Instruction <span style="color: red;">*</span></v-label>
                        <!-- <TextFieldComponent  placeholder="Shipping Instruction" :disabled="viewType === 'view'" v-model="formData.shipping_instruction" /> -->
                        <v-textarea :rules="getRules('Shipping Instruction')" variant="outlined"  placeholder="Shipping Instruction" :disabled="viewType === 'view'" v-model="formData.shipping_instruction"></v-textarea>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-col cols="12" align="end" v-if="viewType === 'edit'">
                <v-btn @click="$emit('close')" class="cancel mr-3" color="gray">
                    Cancel
                </v-btn>
                <v-btn type="submit" class="save" color="rgb(8, 47, 177)">Save</v-btn>
            </v-col>
        </v-form>
    </v-card>
</template>

<script>
// import AutoComplete from "@/components/ui/AutoComplete.vue";
import TextFieldComponent from "@/components/TextFieldComponent.vue";

export default {
    components: {
        // AutoComplete,
        TextFieldComponent,
    },
    data: () => ({
        formData: {
            customer:null,
            name:null,
            ship_type:null,
            shipping_instruction:null,
            active:null,
            created:null,
            created_by:null,
            deleted:null,
            deleted_by:null,
        },
    }),
    props:['designation','shippingForm','viewType','index'],
    created(){
        console.log(this.shippingForm,"customerForm!!!!")
            this.formData.customer = this.shippingForm.customer,
            this.formData.name = this.shippingForm.name,
            this.formData.ship_type = this.shippingForm.ship_type,
            this.formData.shipping_instruction = this.shippingForm.shipping_instruction,
            this.formData.active = this.shippingForm.active
            this.formData.created = this.shippingForm.created
            this.formData.created_by = this.shippingForm.created_by
            this.formData.deleted = this.shippingForm.deleted
            this.formData.deleted_by = this.shippingForm.deleted_by
            this.formData.id = this.shippingForm.id
        console.log(this.formData,'this.@@@')
    },
    
    methods:{
        getRules(name) {
            if (name && name.toLowerCase() === "email") {
                return [
                    (v) => !!v || "E-mail is required.",
                    (v) => /.+@.+\..+/.test(v) || "E-mail must be valid.",
                ];
            }
            return [(v) => !!v || `${name} is required.`];
        },
        async save() {
             const validation = await this.$refs.form.validate();
            if (!validation.valid) {
                console.log("Form not valid");
            } else {
                if(this.viewType == "edit"){
                this.$emit("update-location",this.formData,this.index,this.viewType)
                }
                // else{
                // this.$emit("save", this.formData,this.designation);
                // }
                this.formData = {};
                this.$emit("close");
            } 
        },
    },
}

</script>

<style scoped>
.v-label {
    margin-bottom: 3px;
    font-size: 14px;
    opacity: 1;
    font-weight: 600;
}

.main_title {
    font-size: 16px;
    font-weight: 600;
}

.v-btn-toggle .v-btn {
    background-color: #E9DFFF;

}

.v-btn-toggle {
    height: 32px !important;
}
</style>